module.exports = __webpack_public_path__ + "static/media/bg_red.414bca4f.png";